import React, { useContext, useEffect, useState } from 'react';
import {
    Container, TextField, Button, Box, FormControl, Select, MenuItem, IconButton, Typography, InputLabel
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from '..';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';


export default function SettingsPage() {
    const { companyid, loggedinEmail, isCEO,token } = useContext(AuthContext);
    const [personalViewMode, setPersonalViewMode] = useState("view");
    const [bankViewMode, setBankViewMode] = useState("view");
    const [personalData, setPersonalData] = useState({
        empId: '',
        fullName: '',
        email: '',
        phone: '',
        secondaryPhone: '',
        gender: '',
        country: '',
        state: ''
    });

    const [bankData, setBankData] = useState({
        accountHolderName: '',
        accountNumber: '',
        accountType: '',
        ifscCode: '',
        bankName: '',
        branchName: '',
        branchAddress: '',
        micrCode: ''
    });

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        showCurrent: false,
        showNew: false,
        showConfirm: false,
    });


    const [headerFooterData, setHeaderFooterData] = useState({
        companyid: '',
        logo: '',
        digisign: ''
    });

    const [letterHeadData, setLetterHeadData] = useState({
        companyid: '',
        letterhead: ''
    });

    const handlePersonalChange = (e) => {
        setPersonalData({ ...personalData, [e.target.name]: e.target.value });
    };

    const handleBankChange = (e) => {
        setBankData({ ...bankData, [e.target.name]: e.target.value });
    };

    const handlePasswordChange = (e) => {
        setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
    };

    const handleHeaderFooterChange = (e) => {
        const { name, files } = e.target;
        setHeaderFooterData(prev => ({ ...prev, [name]: files ? files[0] : '' }));
    };

    const handleLetterHeadChange = (e) => {
        const { name, files } = e.target;
        setLetterHeadData(prev => ({ ...prev, [name]: files ? files[0] : '' }));
    };

    const handleLogoSubmit = () => {
        if (!headerFooterData.logo) {
            Swal.fire('Error', 'Please select a logo file!', 'error');
            return;
        }
        const formData = new FormData();
        formData.append('companyid', companyid);
        formData.append('logo', headerFooterData.logo);

        axios.post(`${process.env.REACT_APP_API_LINKS}/settings/logo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((res) => {
                Swal.fire({ icon: 'success', title: 'Success', text: res.data.message || 'Logo saved!', timer: 2000, showConfirmButton: false });
            })
            .catch((err) => {
                Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Something went wrong!' });
            });
    };

    const handleDigisignSubmit = () => {
        if (!headerFooterData.digisign) {
            Swal.fire('Error', 'Please select a digital signature file!', 'error');
            return;
        }
        const formData = new FormData();
        formData.append('companyid', companyid);
        formData.append('digisign', headerFooterData.digisign);

        axios.post(`${process.env.REACT_APP_API_LINKS}/settings/digisign`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((res) => {
                Swal.fire({ icon: 'success', title: 'Success', text: res.data.message || 'Digital signature saved!', timer: 2000, showConfirmButton: false });
            })
            .catch((err) => {
                Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Something went wrong!' });
            });
    };

    const handleLetterHeadSubmit = () => {
        if (!letterHeadData.letterhead) {
            Swal.fire('Error', 'Please select a letterhead file!', 'error');
            return;
        }
        const formData = new FormData();
        formData.append('companyid', companyid);
        formData.append('letterhead', letterHeadData.letterhead);

        axios.post(`${process.env.REACT_APP_API_LINKS}/settings/headerfooterdata`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((res) => {
                Swal.fire({ icon: 'success', title: 'Success', text: res.data.message || 'Letterhead saved!', timer: 2000, showConfirmButton: false });
            })
            .catch((err) => {
                console.log(err)
                Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Something went wrong!' });
            });
    };

    const handlePasswordSubmit = () => {
        if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
            Swal.fire('Error', 'All password fields are required!', 'error');
            return;
        }
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            Swal.fire('Error', 'Passwords do not match!', 'error');
            return;
        }

        axios.post(`${process.env.REACT_APP_API_LINKS}/settings/verify-password`, {
            companyid,
            email: loggedinEmail,
            currentPassword: passwordData.currentPassword
        }, { withCredentials: true })
            .then((res) => {
                if (res.data.success) {
                    axios.post(`${process.env.REACT_APP_API_LINKS}/settings/update-password`, {
                        companyid,
                        email: loggedinEmail,
                        newPassword: passwordData.newPassword
                    }, { withCredentials: true })
                        .then((res) => {
                            Swal.fire('Success', res.data.message || 'Password updated!', 'success');
                            setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
                        })
                        .catch((err) => Swal.fire('Error', err.response?.data?.message || 'Error updating password!', 'error'));
                } else {
                    Swal.fire('Error', 'Current password is incorrect!', 'error');
                }
            })
            .catch((err) => Swal.fire('Error', err.response?.data?.message || 'Verification failed!', 'error'));
    };

    const handleSubmit = (section) => {
        if (section === 'Personal Details') {
            Swal.fire('Success', 'Personal details updated!', 'success');
            setPersonalViewMode("view");
        } else if (section === 'Bank Account Details') {
            if (!bankData.accountNumber || !bankData.bankName || !bankData.ifscCode) {
                Swal.fire('Error', 'Please fill all required bank details!', 'error');
                return;
            }

            const payload = {
                ...bankData,
                companyid: companyid
            };

            axios.post(`${process.env.REACT_APP_API_LINKS}/settings/bank-account`, payload)
                .then(res => {
                    Swal.fire('Success', res.data.message || 'Bank details updated!', 'success');
                    setBankViewMode("view");
                })
                .catch(err => {
                    Swal.fire('Error', err.response?.data?.message || 'Failed to update bank details', 'error');
                });
        }
        else if (section === 'Change Password') {
            handlePasswordSubmit();
        }
    };

    useEffect(() => {
        setHeaderFooterData(prev => ({ ...prev, companyid: companyid }));
        setLetterHeadData(prev => ({ ...prev, companyid: companyid }));
    }, [companyid]);
    useEffect(() => {
        if (!companyid) return;

        axios.get(`${process.env.REACT_APP_API_LINKS}/settings/bank-account`,
            {
                headers:
                {
                    Authorization :`bearer ${token}`
                },
                withCredentials: true
            }
        )
            .then(res => {
                if (res.data && res.data.success && res.data.bankData) {
                    setBankData(res.data.bankData);
                }
            })
            .catch(err => {
                console.error("Error fetching bank account data:", err);
            });
    }, [companyid]);
    const validatePassword = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/;
        return regex.test(password);
    };



    return (
        <Container maxWidth={false} disableGutters sx={{
            py: 1,
            minHeight: 'calc(100vh - 64px)',
            borderRadius: 2,
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row' },
                gap: 4,
                mb: 4,
            }}>
                {/* Personal Details Section - Exactly 8 fields */}
                {/* <Box sx={{
                    flex: 1,
                    borderRadius: 2,
                    boxShadow: '0px 0px 5px #ccc',
                    p: 3,
                    minHeight: { xs: 'auto', md: '500px' },
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#ffffff',
                }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography sx={{ fontWeight: 600, fontSize: '1.25rem' }}>Personal Details</Typography>
                        {(isCEO && personalViewMode === "view") && (
                            <IconButton
                                size="small"
                                onClick={() => setPersonalViewMode("edit")}
                            >
                                <EditIcon sx={{ fontSize: 20, color: "#0b85c8" }} />
                            </IconButton>
                        )}
                    </Box>

                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        margin: "0 auto",
                        width: { xs: "100%", sm: "90%", md: "100%" },
                        // flexGrow: 1,
                        paddingTop: 1,
                        overflowY: 'auto',
                        backgroundColor: '#ffffff',
                    }}>
                        {[
                            { name: "empId", value: personalData.empId, placeholder: "Employee ID" },
                            { name: "fullName", value: personalData.fullName, placeholder: "Full Name" },
                            { name: "email", value: personalData.email, placeholder: "Email" },
                            { name: "phone", value: personalData.phone, placeholder: "Phone" },
                            { name: "secondaryPhone", value: personalData.secondaryPhone, placeholder: "Secondary Phone" },
                            { name: "gender", value: personalData.gender, placeholder: "Gender" },
                            { name: "country", value: personalData.country, placeholder: "Country" },
                            { name: "state", value: personalData.state, placeholder: "State" }
                        ].map((field, index) => (
                            <Box key={index} sx={{ mb: 2, width: '100%' }}>
                                <TextField
                                    name={field.name}
                                    value={field.value}
                                    onChange={handlePersonalChange}
                                    size="small"
                                    fullWidth
                                    label={field.placeholder}
                                    InputLabelProps={{ shrink: !!field.value }}
                                    disabled={personalViewMode === "view"}
                                    sx={{
                                        maxWidth: { xs: "100%", sm: "300px", md: '100%' },
                                        mx: 'auto',
                                        ".MuiInputBase-input": {
                                            fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                        },
                                        "& .MuiOutlinedInput-root fieldset": {
                                            border: "1px solid #ccc",
                                        },
                                    }}
                                />
                            </Box>
                        ))}

                        {(isCEO && personalViewMode === "edit") && (
                            <Box textAlign="center" mt={2}>
                                <Button
                                    onClick={() => handleSubmit("Personal Details")}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#0b85c8",
                                        textTransform: "none",
                                        px: { xs: 2, sm: 4 },
                                        borderRadius: 2,
                                        fontFamily: 'Poppins',
                                    }}
                                >
                                    Update Details
                                </Button>
                            </Box>
                        )}
                    </Box>
                </Box> */}

                {/* Bank Account Details Section - Exactly 8 fields, scrollable if more */}
                <Box sx={{
                    flex: 1,
                    borderRadius: 2,
                    boxShadow: '0px 0px 5px #ccc',
                    p: 3,
                    minHeight: { xs: 'auto', md: bankViewMode === "view" || personalViewMode === "view" ? '500px' : '500px' },
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#ffffff',
                }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography sx={{ fontWeight: 600, fontSize: '1.25rem' }}>Bank Account Details</Typography>
                        {(isCEO && bankViewMode === "view") && (
                            <IconButton
                                size="small"
                                onClick={() => setBankViewMode("edit")}
                            >
                                <EditIcon sx={{ fontSize: 20, color: "#0b85c8" }} />
                            </IconButton>
                        )}
                    </Box>

                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        margin: "0 auto",
                        width: { xs: "100%", sm: "90%", md: "100%" },
                        // flexGrow: 1,
                        paddingTop: 1,
                        overflowY: 'auto'

                    }}>
                        {[
                            { name: "accountHolderName", value: bankData.accountHolderName, placeholder: "Account Holder Name" },
                            { name: "accountNumber", value: bankData.accountNumber, placeholder: "Account Number" },
                            {
                                name: "accountType",
                                value: bankData.accountType,
                                type: "select",
                                options: ["Savings", "Current (Business)"],
                                placeholder: "Account Type"
                            },
                            { name: "ifscCode", value: bankData.ifscCode, placeholder: "IFSC Code" },
                            { name: "bankName", value: bankData.bankName, placeholder: "Bank Name" },
                            { name: "branchName", value: bankData.branchName, placeholder: "Branch Name" },
                            { name: "branchAddress", value: bankData.branchAddress, placeholder: "Branch Address" },
                            { name: "micrCode", value: bankData.micrCode, placeholder: "MICR Code" }
                        ].map((field, index) => (
                            <Box key={index} sx={{ mb: 2, width: '100%' }}>
                                {field.type === "select" ? (
                                    <FormControl
                                        size="small"
                                        sx={{
                                            maxWidth: { xs: "100%", sm: "300px", md: '100%' },
                                            minWidth: { xs: "100%", sm: "200px", md: '100%' },
                                            mx: 'auto'
                                        }}
                                    >
                                        <Select
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleBankChange}
                                            disabled={bankViewMode === "view"}
                                            displayEmpty
                                            renderValue={(selected) => selected || field.placeholder}
                                            sx={{
                                                fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                            }}
                                        >

                                            <MenuItem value="" disabled>
                                                {field.placeholder}
                                            </MenuItem>
                                            {field.options.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                ) : (
                                    <TextField
                                        name={field.name}
                                        value={field.value}
                                        onChange={handleBankChange}
                                        size="small"
                                        fullWidth
                                        label={field.placeholder}
                                        InputLabelProps={{ shrink: !!field.value }}
                                        disabled={bankViewMode === "view"}
                                        sx={{
                                            maxWidth: { xs: "100%", sm: "300px", md: '100%' },
                                            mx: 'auto',
                                            ".MuiInputBase-input": {
                                                fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                            },
                                        }}
                                    />
                                )}
                            </Box>
                        ))}

                        {bankViewMode === "edit" && (
                            <Box textAlign="center" mt={2}>
                                <Button
                                    onClick={() => handleSubmit("Bank Account Details")}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#0b85c8",
                                        textTransform: "none",
                                        px: { xs: 2, sm: 4 },
                                        borderRadius: 2,
                                        fontFamily: 'Poppins',
                                    }}
                                >
                                    Update Bank Details
                                </Button>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>

            {/* Bottom Section - Three in a row for md and lg, one by one for xs and sm */}
            <Box sx={{ borderRadius: 2, mb: 4 }}>
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    flexWrap="wrap"
                    gap={3}
                    sx={{
                        justifyContent: 'space-between'
                    }}
                >
                    {/* Update Password Section */}
                    <Box
                        flex={1}
                        sx={{
                            minWidth: '250px',
                            boxShadow: '0px 0px 5px #ccc',
                            borderRadius: 2,
                            p: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: '#ffffff',
                        }}
                    >
                        <Typography sx={{ fontWeight: 600, fontSize: '1.25rem', mb: 2 }}>Update Password</Typography>
                        <Box display="flex" flexDirection="column" gap={2}>

                            {/* Current Password */}
                            <TextField
                                label="Current Password"
                                type={passwordData.showCurrent ? "text" : "password"}
                                fullWidth
                                size="small"
                                name="currentPassword"
                                value={passwordData.currentPassword}
                                onChange={handlePasswordChange}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setPasswordData(prev => ({ ...prev, showCurrent: !prev.showCurrent }))}
                                                edge="end"
                                            >
                                                {passwordData.showCurrent ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            {/* New Password */}
                            <TextField
                                type={passwordData.showNew ? "text" : "password"}
                                label="New Password"
                                name="newPassword"
                                value={passwordData.newPassword}
                                onChange={handlePasswordChange}
                                size="small"
                                fullWidth
                                error={passwordData.newPassword && !validatePassword(passwordData.newPassword)}
                                helperText={
                                    passwordData.newPassword && !validatePassword(passwordData.newPassword)
                                        ? "Password must be at least 8 characters with uppercase, lowercase, and special character"
                                        : ""
                                }
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setPasswordData(prev => ({ ...prev, showNew: !prev.showNew }))}
                                                edge="end"
                                            >
                                                {passwordData.showNew ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            {/* Confirm Password */}
                            <TextField
                                label="Confirm Password"
                                type={passwordData.showConfirm ? "text" : "password"}
                                fullWidth
                                size="small"
                                name="confirmPassword"
                                value={passwordData.confirmPassword}
                                onChange={handlePasswordChange}
                                error={
                                    passwordData.confirmPassword.length > 0 &&
                                    passwordData.confirmPassword !== passwordData.newPassword
                                }
                                helperText={
                                    passwordData.confirmPassword.length > 0 &&
                                        passwordData.confirmPassword !== passwordData.newPassword
                                        ? "Passwords do not match"
                                        : ""
                                }
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setPasswordData(prev => ({ ...prev, showConfirm: !prev.showConfirm }))}
                                                edge="end"
                                            >
                                                {passwordData.showConfirm ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            {/* Save Button */}
                            <Button
                                onClick={() => handleSubmit("Change Password")}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#0b85c8',
                                    fontFamily: 'Poppins',
                                    textTransform: 'none',
                                    borderRadius: 2,
                                    alignSelf: 'center',
                                    mt: 2,
                                }}
                            >
                                Save Password
                            </Button>
                        </Box>
                    </Box>

                    {/* Letterhead Upload */}
                    <Box
                        // flex={{ xs: '1 1 100%', md: '1 1 30%' }}
                        flex={1}
                        sx={{
                            minWidth: '250px',
                            boxShadow: '0px 0px 5px #ccc',
                            borderRadius: 2,
                            p: 2,
                            border: '2px dashed #0b85c8',
                            backgroundColor: '#ffffff',
                            '&:hover': { backgroundColor: '#f3faff' },
                            alignContent: 'center'
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                textAlign: 'center',
                                minHeight: 150,
                                transition: '0.2s',
                            }}
                        >
                            <PictureAsPdfIcon sx={{ fontSize: 40, color: '#0b85c8', mb: 1 }} />
                            <Button
                                variant="outlined"
                                component="label"
                                sx={{ borderColor: '#0b85c8', color: '#0b85c8' }}
                            >
                                Choose Letter Head
                                <input
                                    type="file"
                                    hidden
                                    name="letterhead"
                                    accept="application/pdf"
                                    onChange={handleLetterHeadChange}
                                />
                            </Button>
                            {letterHeadData.letterhead && (
                                <Box sx={{ mt: 1, color: 'green' }}>
                                    {letterHeadData.letterhead.name}
                                </Box>
                            )}
                            <Button
                                onClick={handleLetterHeadSubmit}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#0b85c8',
                                    fontFamily: 'Poppins',
                                    mt: 2,
                                    textTransform: 'none',
                                    borderRadius: 2,
                                    px: { xs: 2, sm: 4 },
                                }}
                            >
                                Save Letter Head
                            </Button>
                        </Box>
                    </Box>

                    {/* Digital Signature Upload */}
                    <Box
                        flex={1}
                        // flex={{ xs: '1 1 100%', md: '1 1 30%' }}
                        sx={{
                            minWidth: '250px',
                            boxShadow: '0px 0px 5px #ccc',
                            borderRadius: 2,
                            p: 2,
                            border: '2px dashed #0b85c8',
                            backgroundColor: '#ffffff',
                            '&:hover': { backgroundColor: '#f3faff' },
                            alignContent: 'center'
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                textAlign: 'center',
                                minHeight: 150,
                                transition: '0.2s',
                            }}
                        >
                            <BorderColorIcon sx={{ fontSize: 40, color: '#0b85c8', mb: 1 }} />
                            <Button
                                variant="outlined"
                                component="label"
                                sx={{ borderColor: '#0b85c8', color: '#0b85c8' }}
                            >
                                Choose Digital Signature
                                <input
                                    type="file"
                                    hidden
                                    name="digisign"
                                    accept="image/*"
                                    onChange={handleHeaderFooterChange}
                                />
                            </Button>
                            {headerFooterData.digisign && (
                                <Box sx={{ mt: 1, color: 'green' }}>
                                    {headerFooterData.digisign.name}
                                </Box>
                            )}
                            <Button
                                onClick={handleDigisignSubmit}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#0b85c8',
                                    fontFamily: 'Poppins',
                                    mt: 2,
                                    textTransform: 'none',
                                    borderRadius: 2,
                                    px: { xs: 2, sm: 4 },
                                }}
                            >
                                Save Digital Signature
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>      
        </Container>
    );
}